import {createContext, useContext} from "react";

const BgContext = createContext("light");

const Set = ({type, children}) => <BgContext.Provider value={type}>{children}</BgContext.Provider>;

// Within classes use `static contextType = BgContext;`
const Get = ({children}) => <BgContext.Consumer>{children}</BgContext.Consumer>;
const BgCtx = {Get, Set};

export default BgCtx;

export const useBg = () => useContext(BgContext);
